<div class="notification-wrapper">
  <ng-container *ngIf="notification.data.name==userNotificationType.TeamRequestInProgress"></ng-container>
  <div class="notification-title">
    <div class="left">
      <i class="icon-update-24"
         *ngIf="notification?.data?.name==userNotificationType.TeamRequestInProgress" ></i>
      <i class="icon-checkin-required-16"
         *ngIf="notification?.data?.name==userNotificationType.TeamRequestCompleted"> </i>
      <span>{{notification?.message}}</span>
    </div>
    <div class="right">
      <i class="icon-close-default-16" [style.cursor]="'pointer'" (click)="remove.emit(notification.id)"></i>
    </div>
  </div>
  <div class="notification-body-wrapper">
    <div class="title">
      <p class="team-name">{{notification?.data?.teamName}}</p>
      <p>
        <span *ngIf="notification?.data?.name==userNotificationType.TeamRequestInProgress"> {{ 'Translation.Created' | translate }}: </span>
        <span *ngIf="notification?.data?.name==userNotificationType.TeamRequestCompleted"> {{ 'Translation.Completed' | translate }}: </span>
        <span>{{notification.createDate | mPipe: 'MMM DD, YYYY, h:mm A'}}</span>
      </p>
    </div>
    <ng-container>
      <div class="notification-list-wrapper" *ngIf="notification?.data?.name==userNotificationType.TeamRequestCompleted">
        <div class="list">
          <span>{{ 'Translation.Reservations_requested' | translate }}</span>
          <span>{{notification.data.reservationRequestedCount}}</span>
        </div>
        <div class="list">
          <span>{{ 'Translation.Successful' | translate }} </span>
          <span>{{notification.data.reservationCreatedCount}}</span>
        </div>
        <div class="list">
          <span>{{ 'Translation.Unfullfilled' | translate }}</span>
          <div>
            <i *ngIf="notification.data.issueCount > 0" class= "icon-attention-24 error"></i>
            <span [ngClass]="notification.data.issueCount > 0 ? 'error' : 'issueCount'">{{notification.data.issueCount}}</span>
          </div>
        </div>
      </div>
  <div class="links" *ngIf="notification?.data?.name==userNotificationType.TeamRequestCompleted">
    <a [routerLink]="['/bookings/allBookings/dashboard']" [class.disabled]="notification.data.reservationCreatedCount ==0"> {{ 'Translation.Reviewbookings' | translate }}</a>
    <a (click)="navigateToUnfulfilledRequest(notification)" [class.disabled]="notification.data.issueCount ==0"> {{ 'Translation.Review_unfullfilled' | translate }}</a>
  </div>
  </ng-container>
    </div>
</div>
